import { ActionContext, ActionTree } from 'vuex';
import { OrgState, RootState } from '../../types';
import OrgService, { OrgData } from '@/services/org.service';

const actions: ActionTree<OrgState, RootState> = {
  fetchOrgData: (
    store: ActionContext<OrgState, RootState>,
    orgName: string
  ): Promise<void> => {
    return OrgService.getOne(orgName).then((orgData: OrgData) => {
      store.commit('setLogoUrl', orgData.logoUrl);
      store.commit('setShortName', orgName);
      store.commit('setName', orgData.name);
    });
  },
};

export default actions;
